import { useEffect, useRef, useState } from 'react';
import { useNotifications } from '../../contexts/NotificationContext';

export function NotificationBell() {
  const { unreadCount, togglePanel } = useNotifications();
  const previousUnreadRef = useRef(unreadCount);
  const [isPulsing, setIsPulsing] = useState(false);

  useEffect(() => {
    if (unreadCount > previousUnreadRef.current) {
      const rafId = window.requestAnimationFrame(() => {
        setIsPulsing(true);
      });
      const timeout = window.setTimeout(() => {
        setIsPulsing(false);
      }, 900);

      previousUnreadRef.current = unreadCount;
      return () => {
        window.cancelAnimationFrame(rafId);
        window.clearTimeout(timeout);
      };
    }

    previousUnreadRef.current = unreadCount;
    return undefined;
  }, [unreadCount]);

  return (
    <button
      type="button"
      onClick={togglePanel}
      className={`relative p-2 rounded-lg text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors ${
        isPulsing ? 'animate-pulse' : ''
      }`}
      aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
      title="Notifications"
    >
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
        />
      </svg>
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 min-w-4 h-4 px-1 rounded-full bg-red-500 text-[10px] font-bold text-white flex items-center justify-center">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
}
